import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import {useParams } from "react-router-dom";
import "./VideoPage.css";
import { Button, Link } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import CircleIcon from "@mui/icons-material/Circle";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";

function VideoPage() {
  const URL = "https://aa035139-3251-4d74-8a2f-845eafc26dc9.mock.pstmn.io/";

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [videoData, setVideoData] = useState(null);
  const [contentRating, setContentRating] = useState(null);
  const [release, setRelease] = useState(null);
  const [upVote, setUpVote] = useState(0);
  const [downVote, setDownVote] = useState(0);
  const [videolink, setVideolink] = useState("");
  const [error, setError] = useState(null);

  const { id } = useParams();

  const apiCall = useCallback(async () => {
    try {
      const response = await axios.get(URL + "v1/videos");
      setData(response.data.videos);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
    }
  }, [URL]);

  useEffect(() => {
    apiCall();
  }, [apiCall]);

  useEffect(() => {
    if (data) {
      const videoDetail = data.find((e) => e._id === id);
      setVideoData(videoDetail);
      if (videoDetail) {
        setContentRating(videoDetail.contentRating);
        setRelease(videoDetail.releaseDate);
        setUpVote(videoDetail.votes.upVotes);
        setDownVote(videoDetail.votes.downVotes);
        setVideolink(videoDetail.videoLink);
      }
    }
  }, [data, id]);

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  // like buttons

  let upVoteRequest = async () => {
    try {
      let req = await axios.patch(
        `https://8d8f49d1-596f-4897-8918-cad64d5d01b0.mock.pstmn.io/v1/videos/${id}/votes`,
        { upVote: upVote + 1 }
      );
      console.log(req);
      setUpVote(upVote + 1);
    } catch (error) {
      console.error(error);
    }
  };
  let downVoteRequest = async () => {
    try {
      let req = await axios.patch(
        `https://8d8f49d1-596f-4897-8918-cad64d5d01b0.mock.pstmn.io/v1/videos/${id}/votes`,
        { downVote: downVote - 1 }
      );
      console.log(req);
      setDownVote(downVote - 1);
    } catch (error) {
      console.error(error);
    }
  };

  // release date modifier
  let todayDate = new Date();
  let startDate = new Date(release);
  let difference = todayDate.getTime() - startDate.getTime();
  let noOfdays = difference / (1000 * 60 * 60 * 24);
  let displayDate = "";
  if (noOfdays >= 7 && noOfdays < 30) {
    displayDate = Math.floor(noOfdays / 7) + " weeks ago";
  } else if (noOfdays >= 30 && noOfdays < 365) {
    displayDate = Math.floor(noOfdays / 30) + " months ago";
  } else if (noOfdays > 365) {
    displayDate = Math.floor(noOfdays / 365) + " days ago";
  } else {
    displayDate = noOfdays + (noOfdays === 1 ? " day" : " days");
  }




  return (
    <div>
      <Link underline="none" href="/">
      <div
        className="Video_header"
        style={{
          display: "flex",
          justifyContent: "flex-start",
          height: "64px",
        }}
      >
        <img src="Logo.png" alt="logo.png" />
      </div>
      </Link>
      
      <div>
        <iframe
          src={`https://${videolink}`}
          title={videoData?.title}
          style={{ width: "90%", height: "523px" }}
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "#fff",
          width: "100%",
        }}
      >
        <div style={{ marginLeft: "75px" }}>
          {videoData?.title}
          <div className="video_footer">
            <div>{contentRating}</div>
            <div style={{ marginLeft: "10px", marginRight: "10px" }}>
              <CircleIcon sx={{ fontSize: "10px" }} />
            </div>
            <div>{displayDate}</div>
          </div>
        </div>
        <div style={{ marginRight: "70px" }}>
          <Button
            sx={{ borderRadius: "20px", margin: "5px" }}
            variant="contained"
            startIcon={<ThumbUpIcon style={{ fontSize: "12px" }} />}
            onClick={upVoteRequest}
          >
            {upVote}
          </Button>
          <Button
            variant="outlined"
            sx={{ borderRadius: "20px", margin: "5px" }}
            startIcon={
              <ThumbUpIcon
                style={{ transform: "scaleY(-1)", fontSize: "12px" }}
              />
            }
            onClick={downVoteRequest}
          >
            {downVote}
          </Button>
        </div>
      </div>
      <div
        className="row"
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "45px",

        }}
      >
        {data
          ? data.map((e) => {
              return (
                <div className="col-md-3 cards" id={e._id}>
                  <Link underline="none" href={`/video/${e._id}`}>
                    <img
                      src={e.previewImage}
                      alt=""
                      style={{ borderRadius: "10px" }}
                    />
                    <div style={{ textAlign: "start" }}>
                      <h5 style={{ color: "#fff", marginLeft:'12px' }}>{e.title}</h5>
                      <p style={{ color: "#fff", marginLeft:'12px'  }}>{displayDate}</p>
                    </div>
                  </Link>
                </div>
              );
            })
          : ""}
      </div>
    </div>
  );
}

export default VideoPage;
